import _ from 'lodash';

import { getCurrentLocation } from '../selectors/location-history-selectors';
import { getPost } from '../selectors/post-selectors';
import detectRoute, { COMMENT_EDIT_PAGE, POST_EDIT_PAGE } from '../services/detect-route';
import { isPublished } from '@wix/communities-blog-universal/dist/src/post-utils';
import { push } from '../services/router-utils';

const goBack = () => (dispatch, getState) => {
  const state = getState();
  const currentLocation = getCurrentLocation(state);
  const route = detectRoute(currentLocation);

  const parts = _.trim(currentLocation.pathname, '/').split('/');
  parts.pop();

  if (route === COMMENT_EDIT_PAGE) {
    parts.pop();
  }

  if (route === POST_EDIT_PAGE) {
    const post = getPost(getState(), parts[0]);
    parts.pop();

    if (isPublished(post)) {
      parts.push(post.slug);
    }
  }
  const path = `/${parts.join('/')}`;

  return dispatch(push(path));
};

export default goBack;
